import React from 'react'
import PropTypes from 'prop-types'
import { Field, ErrorBubble } from '../../../Components/Form'

export default class Form extends React.Component {

  static propTypes = {
    isProcessing: PropTypes.bool,
    isValid:      PropTypes.bool,
    onChange:     PropTypes.func.isRequired,

    fields: PropTypes.shape({
      username: PropTypes.string.isRequired,
      password: PropTypes.string.isRequired,
    }),

    dictionary: PropTypes.shape({
      error: PropTypes.shape({
        username: PropTypes.string.isRequired,
        password: PropTypes.string.isRequired,
      }),

      login: PropTypes.shape({
        username: PropTypes.string.isRequired,
        password: PropTypes.string.isRequired,
        submit:   PropTypes.string.isRequired,
      }),
    }),
  }

  static defaultProps = {
    isProcessing: false,
    isValid:      false,
  }

  /**
   * Focus on this element once it is mounted.
   */
  firstInput = null

  componentDidMount() {
    // For some reason firstInput is null in jest tests.
    this.firstInput && this.firstInput.focus()
  }

  render() {
    const d = this.props.dictionary
    const disabled = this.props.isProcessing || !this.props.isValid

    let btnClass  = 'btn login-btn-email'.split(' ')
    let bodyClass = []

    if (this.props.isProcessing) {
      bodyClass.push('loginform-processing')
      btnClass.push('btn-disabled')
    }

    return (
      <div className={ bodyClass.join(' ')}>
        <Field>
          <ErrorBubble className="error-bubble error-bubble-twoliner">{ d.error.username }</ErrorBubble>
          <label htmlFor="username">{ d.login.username }</label>
          <input type="text" name="username"
            autoComplete="username"
            placeholder={ d.login.username }
            ref={input => { this.firstInput = input }}
            required
            value={ this.props.fields.username }
            onChange={ this.props.onChange } />
        </Field>
        <Field>
          <ErrorBubble>{ d.error.password }</ErrorBubble>
          <label htmlFor="password">{ d.login.password }</label>
          <input type="password" name="password"
            autoComplete="current-password"
            placeholder={ d.login.password }
            required
            value={ this.props.fields.password }
            onChange={ this.props.onChange } />
        </Field>

        { this.props.isProcessing &&
          <div className="login-processing" /> }

        <input type="submit"
          value={ d.login.submit }
          className={ btnClass.join(' ') }
          disabled={ disabled } />
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./client/Modules/AuthNative/FormBody/FormBody.jsx